import {
  MgState,
  QuestionnaireEntityInterface,
  QuestionnaireRendererEntityInterface,
} from '@types';
import { createSelector } from 'reselect';
import { parseJson } from '@utils';
import {
  createAnswerLoadingSelector,
  editingAnswerLoadingSelector,
  showAgreementLinkSelector,
} from '@selectors/answer';

export const currentQuestionnaireSelector = (store: MgState): QuestionnaireEntityInterface =>
  store?.questionnaire.currentQuestionnaire;

export const currentQuestionnaireRendererSelector = (
  store: MgState
): QuestionnaireRendererEntityInterface => store?.questionnaire.currentQuestionnaire?.renderer;

export const currentQuestionnaireDataSelector = createSelector(
  [currentQuestionnaireSelector],
  (questionnaire) => parseJson(questionnaire?.data)
);

export const questionnaireHeaderLabelsSelector = createSelector(
  [currentQuestionnaireDataSelector],
  (data): string[] => data?.headerLabels || []
);

export const questionnaireRendererDataSelector = createSelector(
  [currentQuestionnaireRendererSelector],
  (questionnaireRenderer) => questionnaireRenderer?.data || ''
);

export const currentQuestionnaireLoadingSelector = (state: MgState) =>
  state.questionnaire.isCurrentQuestionnaireLoading;

export const currentQuestionnaireFailureSelector = (state: MgState) =>
  state.questionnaire.isCurrentQuestionnaireFailure;

export const disableSubmitButtonSelector = (agreed: boolean) =>
  createSelector(
    [currentQuestionnaireDataSelector, createAnswerLoadingSelector, showAgreementLinkSelector],
    (currentQuestionnaireData, isCreateAnswerLoading, showAgreementLink) => {
      if (!showAgreementLink) {
        return isCreateAnswerLoading;
      }
      if (currentQuestionnaireData?.hasAgreement) {
        return !agreed || isCreateAnswerLoading;
      } else {
        return isCreateAnswerLoading;
      }
    }
  );
export const disableSaveButtonSelector = (agreed: boolean) =>
  createSelector(
    [currentQuestionnaireDataSelector, editingAnswerLoadingSelector, showAgreementLinkSelector],
    (currentQuestionnaireData, isEditingAnswerLoading, showAgreementLink) => {
      if (!showAgreementLink) {
        return isEditingAnswerLoading;
      }
      if (currentQuestionnaireData?.hasAgreement) {
        return !agreed || isEditingAnswerLoading;
      } else {
        return isEditingAnswerLoading;
      }
    }
  );

export const currentQuestionnaireLanguageSelector = createSelector(
  [currentQuestionnaireSelector],
  (currentQuestionnaire) => {
    return currentQuestionnaire?.lang;
  }
);
